import React from "react";

/**
 * DownloadIcon component function.
 *
 * @param {Object} cls - the class name to be applied to the SVG element
 * @return {JSX.Element} SVG component representing a download icon
 */
export const DownloadIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cls}
    >
      <path
        d="M20.4164 21.1796H3.58349C3.16267 21.1796 2.81836 20.8353 2.81836 20.4145C2.81836 19.9937 3.16267 19.6494 3.58349 19.6494H20.4164C20.8373 19.6494 21.1816 19.9937 21.1816 20.4145C21.1816 20.8353 20.8373 21.1796 20.4164 21.1796ZM14.1194 17.2468L18.978 12.0822C19.6437 11.4165 19.8349 10.4677 19.4753 9.60315C19.1157 8.73854 18.3123 8.1953 17.3712 8.18765H15.7874L15.7644 5.85399C15.7644 4.17834 14.4025 2.81641 12.7268 2.81641H11.2119C9.53624 2.81641 8.1743 4.17834 8.1743 5.86164V8.17234H6.60577C5.66466 8.17234 4.86127 8.71559 4.50165 9.58784C4.14204 10.4524 4.33332 11.4089 4.98369 12.0516L9.82699 17.2545C10.4161 17.8436 11.1966 18.142 11.977 18.142C12.7575 18.142 13.5302 17.8436 14.127 17.2545L14.1194 17.2468ZM8.93943 9.70261C9.14602 9.70261 9.3373 9.61845 9.48268 9.48072C9.62805 9.33535 9.70457 9.14406 9.70457 8.93748V5.85399C9.70457 5.01999 10.3779 4.34667 11.2119 4.34667H12.7268C13.5608 4.34667 14.2342 5.02764 14.2342 5.86164L14.2571 8.96043C14.2571 9.38126 14.6014 9.71792 15.0222 9.71792H17.3559C17.8226 9.71792 18.0063 10.0775 18.0445 10.1846C18.0904 10.2918 18.2129 10.6743 17.8609 11.0186L13.0176 16.168C12.4284 16.7495 11.4797 16.7418 10.9135 16.1756L6.07018 10.9727C5.74117 10.6437 5.86359 10.2612 5.9095 10.154C5.95541 10.0469 6.13904 9.68731 6.59812 9.68731H8.93943V9.70261Z"
        fill="currentColor"
      />
    </svg>
  );
};
